import { Action } from 'redux';
import * as actions from './actions';
import { FeatureFlagsState } from './types';
import { isType } from 'typescript-fsa';

export const initialFeatureFlagsState: FeatureFlagsState = {
	workListV2: false,
	saveSowLogging: false,
	userManagement: false,
	createSite: false,
	quickSearch: false,
	siteMigration: false,
};

export default function reducer(
	state: FeatureFlagsState = initialFeatureFlagsState,
	action: Action,
): FeatureFlagsState {
	if (isType(action, actions.loadFeatureFlagsAsync.done)) {
		return {
			...state,
			workListV2: action.payload.result.workListV2,
			saveSowLogging: action.payload.result.saveSowLogging,
			userManagement: action.payload.result.userManagement,
			createSite: action.payload.result.createSite,
			quickSearch: action.payload.result.quickSearch,
			siteMigration: action.payload.result.siteMigration,
		};
	}

	return state;
}
